import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Pagination, FormControl, ButtonToolbar, Button } from 'react-bootstrap'
// import Select from 'react-select';
// import Moment, { defaultFormat } from 'moment';
import FontAwesome from 'react-fontawesome';
import IncentivePayeeEditModal from './IncentivePayeeEditModal'
import CashflowStore from '../../stores/CashflowStore'
// var NotificationSystem = require('react-notification-system');
const api = require('api')
const messages = api.getMessage().view.cashflow.IncentivePayeePage
const ROW_PER_PAGE = 10
class IncentivePayeePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      showIncentivePayEdit:false,
      query:'',
      data:{dataList:[]},
      tableData:[],
      dataPerPage:[],
      totalPage:1,
      activePage:1,
    }
  }

  componentDidMount() {
    this.loadData('all','') 
  }

  onTextChange(e) {
    let {query} = this.state
    query = e.target.value
    this.setState({query:query},()=>{
      if (query.length>=3)
        this.loadData('search',this.state.query)
      else if (query.length===0)
        this.loadData('search','')  
    })
  }

  onTextKeyPress(e) {
    if (e.charCode==13) {
      this.loadData('search',this.state.query)
    }
  }

  loadData(viewMode='all',query='') {
    this.setState({loading:true})
    CashflowStore.loadIncentiveExpensePayee(viewMode,query,(result) => {
      let {data} = this.state
      data.dataList = result.data

      let totalPage = 1
      totalPage = result.data.length/ROW_PER_PAGE

      this.setState({data:data,loading:false,tableData:result.data,dataPerPage:this.getPagination(result.data,1),totalPage:Math.ceil(totalPage)})
    })
  }

  getPagination(data,activePage) {
    let page_data = []
    let start = 0
    let count = 0
    if (activePage!==1)
      start = (activePage*ROW_PER_PAGE) - ROW_PER_PAGE

    data.forEach(function(item,index) {
      if (index>=start&&count<ROW_PER_PAGE){
        page_data.push(item)
        count++
      }
    })
    return page_data
  }

  onNewClick() {
    this.refs.incentivePayEdit.loadItemcode(null)
    this.setState({showIncentivePayEdit:true})
  }

  onClearClick() {
    this.setState({query:''})
    this.loadData()
  }

  onAfterSubmit(postData){
    this.onClearClick()
  }

  onPageSelect(e) {
    let {tableData} = this.state
    this.setState({activePage:e,dataPerPage:this.getPagination(tableData,e)})
  }

  onEditClick(item) {
    this.refs.incentivePayEdit.loadItemcode(item)
    this.setState({showIncentivePayEdit:true})
  }

  onRowClick(item){
    
    //this.props.onSelect(item)
    if(typeof this.props.onSelectItem!=='undefined')
      this.props.onSelectItem(item)
  }

  renderSearch() {
    let {query} = this.state
    return(
      <div className='row form-group'>
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)} onKeyPress={this.onTextKeyPress.bind(this)} />
          <ButtonToolbar style={{width:'650px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;{messages['Delete search']}</Button>
            <Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;{messages['Add claim employee']}</Button>
          </ButtonToolbar>
        </div>
      </div>
    )
  }

  renderRowData() {
    let {data,dataPerPage} = this.state
    if (data.dataList.length===0) {
      return(<tr><td colSpan={7}>{messages['No data']}</td></tr>)
    } else {
      return(
        dataPerPage.map((item,index) => {
          return(
            <tr key={index}>
              <td onClick={this.onRowClick.bind(this,item)}>{item.ie_payee_id}</td>
              <td onClick={this.onRowClick.bind(this,item)}>{item.payee_code}</td>            
              <td onClick={this.onRowClick.bind(this,item)}>{item.first_name+' '+item.last_name}</td>
              <td onClick={this.onRowClick.bind(this,item)}>{item.tel}</td>      
              <td onClick={this.onRowClick.bind(this,item)}>{item.bank_name}</td>
              <td onClick={this.onRowClick.bind(this,item)}>{item.bank_account_no}</td>         
              <td>
                <ButtonToolbar>
                  <Button onClick={this.onEditClick.bind(this,item)}>{messages['Edit']}</Button>
                </ButtonToolbar>
              </td>
            </tr>
          )  
        })  
      )
    }  
  }

  renderSearchResult() {
    return(
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th style={{width:'50px'}}>#ID</th>
            <th style={{width:'150px'}}>{messages['Employee ID']}</th>
            <th style={{width:'300px'}}>{messages['Fullname']}</th>     
            <th style={{width:'150px'}}>{messages['Phone']}</th>
            <th style={{width:'150px'}}>{messages['Bank account']}</th>     
            <th style={{width:'150px'}}>{messages['Account number']}</th>  
            <th style={{width:'150px'}}>{messages['View history/Edit']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderPaging() {
    return(
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.onPageSelect.bind(this)}
            />
          </div>
    )
  }

  render() {
  	return(
  	  <div>
  	  	<Box loading={this.state.loading}>
          <Box.Body>
            {this.renderSearch()}
            {this.renderSearchResult()}
            {this.renderPaging()}
          </Box.Body>
        </Box>
        <IncentivePayeeEditModal
          ref={'incentivePayEdit'}
          show={this.state.showIncentivePayEdit}
          onHide={()=>this.setState({showIncentivePayEdit:false})}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
        />
  	  </div>
  	)
  }
}    

export default IncentivePayeePage;


// WEBPACK FOOTER //
// ./src/view/cashflow/IncentivePayeePage.js